export const relationActionTypes = {
    ADD_RELATION: 'ADD_RELATION',
    REMOVE_RELATION: 'REMOVE_RELATION',
    UPDATE_RELATION: 'UPDATE_RELATION',
    CLEAR_RELATION: 'CLEAR_RELATION',
    REMOVE_RELATION_TARGET: 'REMOVE_RELATION_TARGET',
    REMOVE_RELATION_SOURCE: 'REMOVE_RELATION_SOURCE'
  }
  